export default __webpack_public_path__ + "static/media/cana-pescar.60527b21.png";